import { Box, Link, Typography } from '@mui/material';
import CollapsePlain from './Components/CollapsePlain';
import { useTranslation } from 'react-i18next';

const SinglePhone = ({ phone }) => (
    <Link sx={{ fontWeight: 500 }} variant="body2" href={`tel:${phone}`}>
        {phone}
    </Link>
);

export const PhoneField = ({ row }) => {
    const { t } = useTranslation();
    const { phone_numbers } = row;
    if (phone_numbers.length === 0) return null;
    const firstPhone = phone_numbers[0];
    return (
        <Box display="flex" alignItems="center" gap={2}>
            <SinglePhone phone={firstPhone?.phone_number} />
            {phone_numbers.length > 1 && (
                <CollapsePlain
                    tooltip={
                        <Box display="flex" flexDirection="column">
                            <Typography variant="subtitle2" gutterBottom>
                                {t('Phone Numbers')}
                            </Typography>
                            {phone_numbers.map(({ phone_number }, index) => (
                                <SinglePhone phone={phone_number} key={index} />
                            ))}
                        </Box>
                    }
                    length={phone_numbers.length}
                />
            )}
        </Box>
    );
};
